import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { IImageUploadSuccess, IImageUploadSuccessResponse } from '@app/@shared/Models/form-data.model';
import { PageViewTrackingEvent, TrackingInput } from '@app/@core/models/tracking-event.model';
import { InstrumentationService } from '@app/@core/services/instrumentation/instrumentation.service';

@Injectable({
  providedIn: 'root',
})
export class CatalogueService {
  private categories$: Observable<any>;
  public inactiveVariantsObj: any = {};
  public colorMapperObj$ = new BehaviorSubject(null)

  constructor(private http: HttpClient, private instrumentationService: InstrumentationService) { }

  getAllCategory(): Observable<any> {
    if (!this.categories$) {
      this.categories$ = this.http
        .get(environment.with_auth_url + '/seller/api/v1/category')
        .pipe(shareReplay(1));
    }
    return this.categories$;
  }
  getProductTypes(numericId: string) {
    return this.http.get(`${environment.with_auth_url}/product-catalog/api/v3/products/getProductType?numericId=${numericId}`);
  }
  searchCategory(searchText) {
    return this.http.get(environment.with_auth_url +'/productcategory/api/v1/category/trees/'+ searchText+'?pageNo=1&pageSize=50');
  }

  submitBulkFiles(requesBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/product/bulk',
      requesBody
    );
  }

  uploadToMediaStore(requesBody) {
    return this.http.post(
      environment.with_auth_url + '/media-store/files',
      requesBody
    );
  }

  uploadImage(
    requestBody: FormData
  ): Observable<IImageUploadSuccessResponse<IImageUploadSuccess>> {
    return this.http.post<IImageUploadSuccessResponse<IImageUploadSuccess>>(
        `${environment.with_auth_url}/seller/catalog-upload`,
        requestBody
    );
  }

  downloadPriceEditExcl() {
    return this.http.get(
      environment.with_auth_url + '/seller/api/v1/product/bulk/edit/download',
      { responseType: 'blob' }
    );
  }

  uploadPriceEditExcl(requestBody) {
    return this.http.post(
      environment.with_auth_url + '/seller/api/v1/product/bulk/edit ',
      requestBody
    );
  }

  getAllVarients(filterValue?, currentPage?, searchString?) {
    searchString = searchString ? searchString : '';
    // return this.http.get(environment.with_auth_url + '/product-catalog/api/v2/products?isActive=true&pageNo='+ currentPage +'&pageSize=20&pretty=false&showDeleted=false');
    return this.http.get(
      environment.with_auth_url +
      '/seller/api/v1/product?state=' +
      filterValue +
      '&isActive=true&pageNo=' +
      currentPage +
      '&pageSize=20&sortBy=updatedDate:DESC&pretty=false&searchString=' +
      searchString
    );
  }

  getAllInactiveVariantsForProduct(productId, currentPage) {
    return this.http.get(
      environment.with_auth_url +
      '/seller/api/v1/product/' +
      productId +
      '/variants/inactive?pageNo=' +
      currentPage +
      '&pageSize=20&sortBy=updatedDate:DESC'
    );
  }

  getAllDraftProduct(page, searchString) {
    return this.http.get(environment.with_auth_url + '/seller/api/v1/product?pageNo=' + page + '&pageSize=20&sortBy=updatedDate:DESC&pretty=false&state=DRAFTED&searchString=' + searchString);
  }

  getFromMediaStore(imageKey) {
    const url =
      environment.without_auth_url + '/cmedia-store/files/' + imageKey;
    return url;
  }

  editVarients(requestBody) {
    return this.http.put(
      environment.with_auth_url + '/seller/api/v1/product/variant',
      requestBody
    );
  }

  moveToPublish(requestBody) {
    // /product-catalog/api/v3/products/publish
    const url = environment.with_auth_url + '/seller/api/v1/product/state';
    return this.http.put(url, requestBody);
  }

  changeVariantState(requestBody) {
    const url =
      environment.with_auth_url + '/seller/api/v1/product/variant/status';
    return this.http.put(url, requestBody);
  }

  editAndPublishVariant(requestBody) {
    return this.http.put(
      environment.with_auth_url +
      '/seller/api/v1/product/variant?isPublishVariant=true',
      requestBody
    );
  }

  movePendingProductsToPublish(requestBody) {
    return this.http.post(environment.with_auth_url + '/seller/api/v1/product/approve', requestBody);
  }

  // New Implementation Starts from Here

  getAllVariants(state, currentPage, searchString) {
    let params = new HttpParams();
    params = params.append('state', state);
    // params = params.append('state', 'LOW_IN_STOCK');
    params = params.append('pageNo', currentPage);
    params = params.append('pageSize', '20');
    params = params.append('sortBy', 'updatedDate:DESC');
    params = params.append('searchString', searchString);
    return this.http.get(environment.with_auth_url + '/seller/api/v1/product/variants', { params: params })
  }

  getVariantsBasedonProductId(state, productId, pageSize, currentPage?) {
    let params = new HttpParams();
    params = params.append('state', state);
    params = params.append('sortBy', 'updatedDate:DESC');
    if (pageSize)
      params = params.append('pageSize', `${pageSize}`);
    if (currentPage)
      params = params.append('pageNo', `${currentPage}`);
    params = params.append('productId', productId);
    // params = params.append('searchString', searchString);
    return this.http.get(environment.with_auth_url + '/seller/api/v1/product/variants', { params: params })
  }

  getAllVariantsList(state, currentPage, searchString) {
    let params = new HttpParams();
    params = params.append('reviewState', state);
    params = params.append('pageNo', currentPage);
    params = params.append('pageSize', '20');
    //params = params.append('sellerId', 'fa89be58-14f0-4ad2-8c31-677d4fdd0927');
    // params = params.append('sortBy', 'updatedDate:DESC');
    params = params.append('searchString', searchString);
    return this.http.get(environment.with_auth_url + '/seller/api/v1/product/review/variant-list', { params: params })
  }

  getVariantsBasedonProductReviewId(productReviewId) {
    let params = new HttpParams();
    let reqId : any = new Date().getTime();
    params = params.append('request-id', reqId);
    return this.http.get(environment.with_auth_url + '/seller/api/v1/product/review/product-review-details/'+productReviewId, {params:params})
  }

  sendToQC(payload){
    return this.http.post(environment.with_auth_url + '/product-catalog/api/v3/products', payload);
  }

  getColorMapper() {
    const url = "/seller/api/v1/product/getAllColorWithCode"
    return this.http.get(environment.with_auth_url+ url)
  }

  setColor(colorObj){
    const mapper ={}
    colorObj.map(obj=>{
      mapper[obj.color] = obj.code
    })
    this.colorMapperObj$.next(mapper)
  }
  logPageViewEvent(pageName): void{
    const trackingInput: TrackingInput<PageViewTrackingEvent> = {
        eventLabel: 'Page Viewed',
        eventName: 'PAGE_VIEWED',
        eventSource: 'Menu Bar',
        pageName: pageName,
        viewedAt: Date.now()
    };
    this.instrumentationService.logEvent<PageViewTrackingEvent>(trackingInput);
  }
}
